import * as React from 'react';

import { get as userGet } from 'js/lib/user';

import { useEnterpriseMyPageHeader } from 'bundles/composable-page-header-enterprise/contexts/EnterpriseMyPageHeaderContext';
import EnterpriseDesktopLoggedInMainNav from 'bundles/composable-page-header-enterprise/main-nav-modules/desktop/EnterpriseDesktopLoggedInMainNav';
import EnterpriseDesktopLoggedOutMainNav from 'bundles/composable-page-header-enterprise/main-nav-modules/desktop/EnterpriseDesktopLoggedOutMainNav';
import EnterpriseMobileLoggedInMainNav from 'bundles/composable-page-header-enterprise/main-nav-modules/mobile/EnterpriseMobileLoggedInMainNav';
import EnterpriseMobileLoggedOutMainNav from 'bundles/composable-page-header-enterprise/main-nav-modules/mobile/EnterpriseMobileLoggedOutMainNav';
import DefaultEnterprisePageHeaderProvider from 'bundles/composable-page-header-enterprise/providers/DefaultEnterprisePageHeaderProvider';
import LegacyGDPRBannerWrapper from 'bundles/composable-page-header/banners/LegacyGDPRBannerWrapper';
import GlobalPageHeaderContainer from 'bundles/composable-page-header/components/GlobalPageHeaderContainer';
import GlobalPageHeaderStateProvider from 'bundles/composable-page-header/providers/GlobalPageHeaderStateProvider';

const EnterprisePageHeader = () => {
  const { currentPageProgram } = useEnterpriseMyPageHeader();
  const user = userGet();

  if (!currentPageProgram) {
    return null;
  }

  const getDesktopNav = () => {
    if (user?.id) {
      return EnterpriseDesktopLoggedInMainNav;
    } else {
      return EnterpriseDesktopLoggedOutMainNav;
    }
  };
  const getMobileNav = () => {
    if (user?.id) {
      return EnterpriseMobileLoggedInMainNav;
    } else {
      return EnterpriseMobileLoggedOutMainNav;
    }
  };

  const DesktopNavComponent = getDesktopNav();
  const MobileNavComponent = getMobileNav();

  return (
    <GlobalPageHeaderContainer
      desktopMainNav={<DesktopNavComponent />}
      mobileMainNav={<MobileNavComponent />}
      banners={[{ name: 'GDPRBanner', component: <LegacyGDPRBannerWrapper /> }]}
    />
  );
};

const EnterprisePageHeaderWithProvider = () => {
  return (
    <GlobalPageHeaderStateProvider>
      <DefaultEnterprisePageHeaderProvider>
        <EnterprisePageHeader />
      </DefaultEnterprisePageHeaderProvider>
    </GlobalPageHeaderStateProvider>
  );
};

export default EnterprisePageHeaderWithProvider;
